import { Env } from '@bloomays-lib/types.shared';
import { getEnvOrThrow } from './env.utils';

export const SIGNED_WEBHOOK_PATH = '/webhooks/yousign/signed';
export const LEGACY_SIGNED_WEBHOOK_PATH = '/webhooks/signnow/signed';

export const testLKUrl = (url: string) => {
  const LKRegex = /^https:\/\/(www\.)?linkedin\.com\/in\/[^/]+\/?$/;
  return LKRegex.test(url);
};

export const testGHUrl = (url: string) => {
  const GHRegex =
    /^https?:\/\/(?:[a-z0-9]+\.)?github\.com\/(?:(?:[\wÀ-ÖØ-öø-ÿ-]+-){0,2}[\wÀ-ÖØ-öø-ÿ]+(?:\.[\wÀ-ÖØ-öø-ÿ]+)*\/?)?$/;
  return GHRegex.test(url);
};

export const testTurnOverITUrl = (url: string) => {
  const TOITRegex = /^https:\/\/app\.turnover-it\.com\/cv-library\/\d+.$/;
  return TOITRegex.test(url);
};

export const testHelloWorkUrl = (url: string) => {
  const TOITRegex = /^https:\/\/app-recruteur\.hellowork\.com\/applicant\/detail\/\d+.$/;
  return TOITRegex.test(url);
};

export const getLKSlug = (url: string) => {
  const urlParsed = new URL(
    url
      .replace('//linkedin.com', '//www.linkedin.com')
      .replace('//fr.linkedin.com', '//www.linkedin.com')
      .replace('http://', 'https://'),
  );
  const pathnames = urlParsed.pathname.split('/');
  if (pathnames?.[1] === 'in') {
    return `${urlParsed.origin}/${pathnames[1]}/${pathnames[2]}/`;
  }
  return `${urlParsed.origin}${urlParsed.pathname}`;
};

export const getHWSlug = (profileId: number) => {
  return `https://app-recruteur.hellowork.com/applicant/detail/${profileId}`;
};

export const getTOITSlug = (profileId: number) => {
  return `https://app.turnover-it.com/cv-library/${profileId}`;
};

export const getATSUrl = (env: Env) => {
  return env === 'production'
    ? 'https://app.hiresweet.com/client/bloomays'
    : 'https://app.hiresweet.com/client/bloomays-d06';
};

export const getATSTalentUrl = (env: Env, talentId: string) => {
  return `${getATSUrl(env)}/reveal/search?profileId=${talentId}`;
};

const COLLECTIVE_WEB_APP_ORIGIN = 'https://app.collective.work';
const HUBSPOT_ENDPOINT = 'https://app-eu1.hubspot.com/contacts/139539088';

/** Profil talent dans l’app Collective : `collectiveUserId` = valeur stockée côté TalentHub (`collectiveId`). */
export const getCollectiveTalentUrl = (collectiveUserId: string): string => {
  const profileId = encodeURIComponent(collectiveUserId.trim());
  return `${COLLECTIVE_WEB_APP_ORIGIN}/recruiter/import-users?profileId=${profileId}`;
};

export const getATSJobUrl = (env: Env, projectId: string, talentId?: string) => {
  const url = `${getATSUrl(env)}/reveal/projects/recruiting/${projectId}/profiles`;
  if (talentId) {
    return `${url}?item=${talentId}`;
  }
  return url;
};

export const getBullMqBaseUrl = (): string => {
  if (process.env.NODE_ENV === 'production') {
    return `https://jobs.bloomays.com`;
  }
  if (process.env.NODE_ENV === 'staging') {
    return `https://jobs-staging.bloomays.com`;
  }
  return `http://localhost:3001`;
};

export const getPublicClientAppEndpoint = (): string => {
  const endPoint = getEnvOrThrow('PUBLIC_CLIENT_APP_ENDPOINT');
  return endPoint;
};

export const getPublicBloomersAppEndpoint = (): string => {
  const endPoint = getEnvOrThrow('PUBLIC_APP_ENDPOINT');
  return endPoint;
};

export const getTalentAppJobUrl = (jobId: string): string => {
  const endPoint = getPublicBloomersAppEndpoint().replace(/\/$/, '');
  return `${endPoint}/jobs/${jobId}`;
};

export const getElectronicSignAppUrl = (externalDocumentId: string, signerId: string, token?: string) => {
  const url = `${process.env.PUBLIC_APP_ENDPOINT}/electronicSign/${externalDocumentId}/${signerId}`;
  if (token) {
    return `${url}?token=${token}`;
  }
  return url;
};

export const getPublicSignedCRAURL = (signingDocumentId: string): string => {
  const endPoint = getPublicBloomersAppEndpoint();
  return `${endPoint}/public/cra/${signingDocumentId}/cra.pdf`;
};

export const getTalentBoardJobUrl = (jobId: string): string => {
  const endPoint = getPublicClientAppEndpoint().replace(/\/$/, '');
  return `${endPoint}/talentboard/jobs/${jobId}`;
};

export const getTalentBoardPageTalentUrl = (jobId: string, talentId: string): string => {
  const endPoint = getPublicClientAppEndpoint();
  return `${endPoint}/talentboard/jobs/${jobId}/talent/${talentId}`;
};

export const getHubspotDealUrl = (hubspotDealId: string): string => {
  return `${HUBSPOT_ENDPOINT}/record/0-3/${hubspotDealId}`;
};

export const getPrivateAdminDashboardMissionUrl = (missionRecordId: string): string => {
  const endPoint = getPublicBloomersAppEndpoint();
  return `${endPoint}/missions/${missionRecordId}`;
};

export const getBillingsActivityUrl = (): string => {
  const endPoint = getPublicBloomersAppEndpoint();
  return `${endPoint}/billingsActivity`;
};
